var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('label',{staticStyle:{"margin-top":"15px","font-weight":"bold","margin-left":"25px"}},[_vm._v("告警分布")]),_c('pie-chart',{ref:"pieChart",staticStyle:{"height":"80%"},attrs:{"data":_vm.alarmData,"extendData":_vm.extendData,"id":"AlarmDistribution","route":_vm.route}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }